var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['spinner', { '-rainbow': _vm.rainbow }],style:({width: _vm.width})},[_c('svg',{staticClass:"circular",style:({animationDuration: _vm.duration + 's'}),attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",style:({animationDuration: _vm.duration * (3/4) + 's'}),attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke":_vm.color,"stroke-width":_vm.strokeWidth,"stroke-miterlimit":"10"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-412a114a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner/Spinner.vue
// module id = null
// module chunks = 